"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeAggregation = exports.setAggregationAction = exports.toggleAggregationAction = void 0;
const SET = "ducks/aggregation/SET";
const TOGGLE = "ducks/aggregation/TOGGLE";
const MERGE = "ducks/aggregation/MERGE";
exports.toggleAggregationAction = aggregation => ({
    type: TOGGLE,
    aggregation: aggregation
});
exports.setAggregationAction = id => ({
    type: SET,
    aggregation: id
});
exports.mergeAggregation = (samples) => ({
    type: MERGE,
    samples: samples
});
const currentAggregation = (state = [], action) => {
    switch (action.type) {
        case SET:
            return action.aggregation;
        case TOGGLE: {
            let newState = state.slice(0);
            action.aggregation.forEach(vector => {
                if (newState.includes(vector)) {
                    newState.splice(newState.indexOf(vector), 1);
                }
                else {
                    newState.push(vector);
                }
            });
            return newState;
        }
        case MERGE: {
            let newState = state.slice(0);
            action.samples.forEach(sample => {
                if (!sample.view.selected) {
                    newState.push(sample);
                }
            });
            return state;
        }
        default:
            return state;
    }
};
exports.default = currentAggregation;
